<template>
    <div>
        <!-- 搜索 -->
        <search  :search="true" :type="'RoleManagement'" @add-data="add_data" @search-data="search_data" @Export="Export"></search>
        <!-- 列表 -->
        <tables id="table-box"  :tableData="tableData"  :tableLabel="tableLabel" :ifheader="false" :Calculate="false" @event-button="event_button" ></tables>
        <!-- 新增角色 -->
        <el-dialog :close-on-click-modal="false" :visible.sync="New_Menu" :title="title"  :width="'720px'" v-if="New_Menu">
            <NewRole :visibles.sync="New_Menu" @Render="Render" :type="type" :row="row"></NewRole>
        </el-dialog>
        <!-- 关联菜单 -->
        <el-dialog   :close-on-click-modal="false" :visible.sync="New_Context_Menu" :title="title"  :width="'720px'" v-if="New_Context_Menu">
            <ContextMenu :visibles.sync="New_Context_Menu" @Render="Render" :type="type" :row="row"></ContextMenu>
        </el-dialog>
        <!-- 关联权限 -->
        <!-- <el-dialog :close-on-click-modal="false" :visible.sync="New_permissions" :title="title"  :width="'720px'" v-if="New_permissions">
            <AssignPermissions :visibles.sync="New_permissions" @Render="Render" :type="type" :row="row"></AssignPermissions>
        </el-dialog> -->
           <!-- 关联接口 -->
        <el-dialog  custom-class="my-info-dialog" :close-on-click-modal="false" :visible.sync="New_permissions" :title="title"  :width="'40%'" v-if="New_permissions">
            <Cominterface
              :SelectDataList="SelectDataList"
              :data="SelectinterfaceList"
              @submit="submit"
              :visible.sync="New_permissions"
            ></Cominterface>
        </el-dialog>
         <!-- 分页 -->
        <pagination
            v-show="(Number(total) > 0)"
            :total="Number(total)"
            :page.sync="matterParams.current"
            :limit.sync="matterParams.size"
            @pagination="Render"
        />
    </div>
</template>
<script>
import NewRole from '../dialog/NewRole'
import ContextMenu from '../dialog/ContextMenu'
// 关联权限
// import AssignPermissions from '../dialog/AssignPermissions'
// 关联接口
import Cominterface from '../dialog/Cominterface'
// import Distributioninterface from '../dialog/Distributioninterface'
export default {
  components: {
    NewRole,
    ContextMenu,
    // AssignPermissions,
    Cominterface
  },
  // props: {
  // '': {
  //    type:Object|Array|String|Boolean|Number
  //  }
  // },
  data () {
    return {
      New_Menu: false,
      New_Context_Menu: false,
      New_permissions: false,
      title: '',
      total: 0,
      type: '',
      row: {},
      SelectDataList: {},
      SelectinterfaceList: {},
      matterParams: {
        // 默认显示页数
        current: 1,
        // 一页几条数据
        size: 10,
        orders: 'gmtCreate|desc'
      },
      tableData: [
      ],
      tableLabel: [
        { label: '序号', width: '80', prop: 'index', type: '', align: 'center' },
        { label: '角色名称', width: '', prop: 'name', align: 'center' },
        { label: '角色描述', width: '', prop: 'description', align: 'center' },
        {
          label: '操作',
          width: '',
          align: 'center',
          isOpera: true, // 判断是否生成按钮
          ifshow: false, // 是否导出该内容
          titleList: [
            { title: '分配菜单', status: 'primary' },
            { title: '分配接口', status: 'primary' },
            { title: '修改', status: 'primary' },
            { title: '删除', status: 'primary' }
          ]
        }
      ]
    }
  },
  methods: {
    // 新增
    add_data (v) {
      this.title = '新增角色'
      this.New_Menu = true
      this.type = 'add'
      this.row = {}
    },
    // 查询数据
    search_data (row, type) {
      this.matterParams.current = 1
      Object.assign(this.matterParams, row)
      this.Render()
    },
    // 导出
    Export () {
      this.tableLabel[3].ifshow = true
      setTimeout(() => {
        this.$tableToExcel('#table-box .el-table', '角色信息.xlsx')
        this.tableLabel[3].ifshow = false
      })
      this.$message.success('导出成功')
    },
    // 列表按钮
    event_button (type, row) {
      if (type === '修改') {
        this.New_Menu = true
        this.title = '修改角色'
        this.type = 'edit'
        this.row = row
      } else if (type === '删除') {
        this.$confirm(`此操作将永久删除<span style="color:red"> ${row.name} </span> 该角色, 是否继续?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          dangerouslyUseHTMLString: true // 将dangerouslyUseHTMLString属性设置为 true，message 就会被当作 HTML 片段处理
        }).then(() => {
          this.$http.Delete('/ucenter/role/deleteRole', { id: row.id }).then((res) => {
            this.$message.success('删除成功')
            this.Render()
          })
        }).catch(() => {})
      } else if (type === '新增角色') {
        this.New_Menu = true
        this.title = '新增角色'
        this.type = 'AddMenu'
        this.row = row
      } else if (type === '分配菜单') {
        this.New_Context_Menu = true
        this.row = row
        this.title = '关联菜单'
      } else if (type === '分配接口') {
        var that = this
        that.$http.get('/path/api-url/listByRoleId', { roleId: row.id }).then((res) => {
          that.SelectDataList = {
            roleId: row.id,
            value: [],
            Selected: []
          }
          if (res.data.length > 0) {
            // 已选中数据
            that.SelectDataList.Selected = res.data.filter((item) => { return item.chose === 1 })
            // 全部数据
            that.SelectDataList.value = res.data
          }
          that.New_permissions = true
          that.title = '分配接口'
        })
      }
    },
    // 提交
    submit (val) {
      const urlIdsList = []
      const lis = { roleId: val.roleId, urlIds: [] }
      val.value.forEach((item) => {
        lis.urlIds.push(item)
      })
      lis.urlIds.forEach((item) => {
        urlIdsList.push(item.id)
        lis.urlIds = urlIdsList
      })
      this.$http.post('/role/role-url/save', lis).then((res) => {
        if (res.status === 200) {
          this.$message.success('分配成功')
          this.$emit('update:visibles', false)
          this.$emit('Render')
        } else {
          this.$message.error('分配失败')
          this.$emit('update:visibles', true)
        }
      })
    },
    // 列表数据
    Render () {
      this.$http.get('/ucenter/role/queryPage', this.matterParams).then((res) => {
        this.tableData = res.data.records
        this.total = res.data.total
      })
      // this.$http.get('/dict/department/queryPageTree', this.matterParams).then((res) => {
      //   this.tableData = res.data.records
      //   this.tableData = res.data.records
      //   this.total = res.data.total
      // })
    }
  },
  created () {
    this.Render()
  },
  watch: {
  },
  mounted () {
  }
}
</script>
<style lang="scss">
  .el-dialog .my-info-dialog{
    margin-top: 1vh !important;
  }
</style>
